<template> 
  <f7-page name="edit" hide-navbar-on-scroll>
    <f7-navbar>
      <f7-nav-left>
        <SuntioLogo/>
      </f7-nav-left>
      <f7-nav-right>
        <f7-icon f7="arrow_right_square" @click="logout"></f7-icon>
      </f7-nav-right>
    </f7-navbar>
    <f7-toolbar bottom>
      <small style="color:gray;">{{ $t('copyright') }}</small>
    </f7-toolbar>

    <span v-if="ldapuser && !edit_info_id">
      <f7-block>
        <img :src="ldapuser.selfie" style="max-width:99%;"/>
      </f7-block>
      <f7-list media-list>
        <f7-list-item :header="$t('general_uid-label')" :title="ldapuser.uid" ></f7-list-item>
        <f7-list-item :header="$t('general_givenname-label')" :title="ldapuser.givenname"></f7-list-item>
        <f7-list-item :header="$t('general_sn-label')" :title="ldapuser.sn"></f7-list-item>
        <f7-list-item :header="$t('general_gender-label')" :title="ldapuser.gender"></f7-list-item>
        <f7-list-item :header="$t('general_dateofbirth-label')" :title="ldapuser.dateofbirth"></f7-list-item>
        <f7-list-item :header="$t('email-label')" :title="ldapuser.emailaddress" :badge="ldapuser.emailverified?'verificat':'neverificat'" :badge-color="ldapuser.emailverified?'green':'red'"></f7-list-item>
        <f7-list-item :header="$t('mobile')" :title="ldapuser.mobile" :badge="ldapuser.phonenumberverified?'verificat':'neverificat'" :badge-color="ldapuser.phonenumberverified?'green':'red'"></f7-list-item>
        <f7-list-item :header="$t('placeofbirth')" :title="ldapuser.placeofbirth" ></f7-list-item>
        <f7-list-item :header="$t('serialnumber')" :title="ldapuser.documentidentifier">
          <img :src="ldapuser.idcard" style="width:99%;"/>
        </f7-list-item>
      </f7-list>
    </span>
    <span v-if="!edit_info_id && authenticated">
      <f7-list>
        <f7-list-item link="#" @click="edit_info_method(1)">{{ $t('edit_btn-update-email-label') }}</f7-list-item>
        <f7-list-item link="#" @click="edit_info_method(2)">{{ $t('edit_btn-update-phone-label') }}</f7-list-item>
        <!-- f7-list-item link="#" @click="edit_info_method(3)">{{ $t('edit_btn-update-identitycard-label') }}</f7-list-item -->
      </f7-list>

      <f7-list>
        <f7-list-item link="#" @click="delete_me">{{ $t('delete') }}</f7-list-item>
      </f7-list>
      <f7-block>
        <f7-card :content="$t('edit_block-delete-account-notice')"></f7-card>
      </f7-block>

      <f7-list>
        <f7-list-item link="#" @click="logout">{{ $t('logout') }}</f7-list-item>
      </f7-list>
    </span>

    <span v-if="authenticated">
      <span block v-if="edit_info_id == 1">
        <span v-if="!email_change_flag">
          <f7-block>
            {{ $t('edit_block-input-email-message_line_1') }} 
            {{ $t('edit_block-input-email-message_line_2') }}
          </f7-block>
          <f7-list>
            <f7-list-input
              type="email"
              :placeholder="$t('email-placeholder', { account: 'nume.prenume', domain: 'domeniu'})"
              :info="$t('email-error_message')"
              minlength=5
              maxlength=64
              required
              validate
              :error-message="$t('email-error_message')"
              clear-button
              @input="email_temp=$event.target.value"
              :label="$t('data_new-email_label')"
              :onValidate="(isValid)=>setEmailValid(isValid)"
            >
            </f7-list-input>
            <f7-list-input
              type="email"
              :placeholder="$t('email_new-repeat_placeholder')"
              :info="$t('email-error_message')"
              minlength=5
              maxlength=64
              required
              validate
              :error-message="$t('email-error_message')"
              clear-button
              @input="email_confirm_temp=$event.target.value"
              :label="$t('data_new_-email_repeat_label')"
              :onValidate="(isValid)=>setEmailConfirmValid(isValid)"
            >
            </f7-list-input>
          </f7-list>
          <f7-list>
            <f7-list-item link="#" :disabled="validate_email_accept_btn" @click="change_email_method(1)" >{{ continue_btn_text }}</f7-list-item>
          </f7-list>
        </span>
        <span v-else-if="email_change_flag">
          <f7-block>
            {{ $t('edit_block-notice-confirmation-email-sent_line_1') }} {{email_temp}}.
            {{ $t('edit_block-notice-confirmation-email-sent_line_2') }}
          </f7-block>
          <small>{{ $t('edit_block-notice-check-inbox-spam') }}</small>
          <f7-list>
            <f7-list-input
              type="password"
              inputmode="numeric"
              placeholder="1234"
              :info="$t('edit_block-notice-check-inbox-spam')"
              :label="$t('email_verify-title')"
              minlength=4
              maxlength=4
              clear-button
              @input="verifyEmailPin"
            >
            </f7-list-input>
          </f7-list>
        </span>
      </span>

      <span v-else-if="edit_info_id == 2">
        <span v-if="!mobile_change_flag">
          <f7-block>
            {{ $t('edit_block_input-phone_message_line_1') }}
            {{ $t('edit_block_input-phone_message_line_2') }}
          </f7-block>
          <f7-list>
            <f7-list-input
              type="tel"
              inputmode="numeric"
              :placeholder="$t('phone_number-placeholder')"
              :info="$t('email-error_message')"
              minlength=9
              maxlength=15
              pattern="[0-0]{1}[7][0-9]{8}"
              required
              validate
              :error-message="$t('phone_number-error-message')"
              clear-button
              @input="mobile_temp=$event.target.value"
              :label="$t('data_new-phone_label')"
              :onValidate="(isValid)=> setPhoneValid(isValid)"
            >
            </f7-list-input>
            <f7-list-input
              type="tel"
              inputmode="numeric"
              :placeholder="$t('phone_number-placeholder')"
              :info="$t('email-error_message')"
              minlength=9
              maxlength=15
              pattern="[0-0]{1}[7][0-9]{8}"
              required
              validate
              :error-message="$t('phone_number-error-message')"
              clear-button
              @input="mobile_confirm_temp=$event.target.value"
              :label="$t('data_new-phone_repeat_label')"
              :onValidate="(isValid)=> setPhoneConfirmValid(isValid)"
            >
            </f7-list-input>
            <f7-list>
              <f7-list-item link="#" :disabled="validate_phone_accept_btn" @click="change_phone_method(1)" >{{ continue_btn_text }}</f7-list-item>
            </f7-list>
          </f7-list>
        </span>
        <span v-else-if="mobile_change_flag">
          <f7-block>
            {{ $t('edit_block_notice-confirmation-sms-sent_line_1') }} {{mobile_temp}}.
            {{ $t('edit_block_notice-confirmation-sms-sent_line_2') }}
          </f7-block>
          <f7-list>
            <f7-list-input
              outline
              type="password"
              inputmode="numeric"
              :label="$t('phone_number_verify-title')"
              floating-label
              minlength=4
              maxlength=4
              clear-button
              @input="verifyPhonePin"
            >
            </f7-list-input>
          </f7-list>
        </span>
      </span>

      <!-- f7-block-title v-else-if="edit_info_id==3">
        Momentan Indisponibil
      </f7-block-title-->

      <f7-block-title v-if="edit_info_id!=null && (mobile_change_flag||email_change_flag)">
        {{ $t('edit_block_encountering-issues-contact_line_1') }}
      </f7-block-title>
      <f7-list v-if="edit_info_id!=null">
        <f7-list-item link="mailto:info@lendrise.com?subject=Asistență schimbare date personale" external> {{ $t('edit_block_encountering-issues-contact_line_2') }}</f7-list-item>
        <f7-list-item link="#" @click="reset_main_infos">{{ $t('cancel') }}</f7-list-item>
      </f7-list>
    </span>
  </f7-page>
</template>
<script>
  import { f7, f7ready } from 'framework7-vue';
  import { SuntioLogo } from '../icons-svg/icons-svg.js';
  import { request } from 'framework7';

  export default {
    props: {
      f7router: Object,
      person: Object,
    },
    components: {
      SuntioLogo,
    },
    computed: {
      validate_email_accept_btn: function() {
        const self=this;
        const ok_to_continue=(self.email_is_valid && self.email_confirm_is_valid);
        const emails_alike = (self.email_temp == self.email_confirm_temp);
        const email_same_old = (self.email_temp == self.ldapuser.emailaddress);

        if (email_same_old){
          self.continue_btn_text=self.$t('email_same_as_old-label');
          return email_same_old;
        } 

        if(ok_to_continue && emails_alike)
          self.continue_btn_text=self.$t('continue');
        else if (ok_to_continue && !emails_alike)
          self.continue_btn_text=self.$t('email_new_alike_error-label');
        else if(!ok_to_continue && !emails_alike)
          self.continue_btn_text=self.$t('email_required_warning-label');
        return !ok_to_continue || !emails_alike;
      },
      validate_phone_accept_btn: function() {
        const self=this;
        const ok_to_continue=(self.mobile_is_valid && self.mobile_confirm_is_valid);
        const phones_alike = (self.mobile_temp == self.mobile_confirm_temp);
        const phone_same_old = (('+4' + self.mobile_temp) == self.ldapuser.mobile);
        if (phone_same_old){
          self.continue_btn_text=self.$t('phone_number_same-as-old-error');
          return phone_same_old;
        }

        if(ok_to_continue && phones_alike)
          self.continue_btn_text=self.$t('continue');
        else if (ok_to_continue && !phones_alike)
          self.continue_btn_text=self.$t('phone_number_alike_error-label');
        else if(!ok_to_continue && !phones_alike)
          self.continue_btn_text=self.$t('phone_number_required_warning-label');
        return !ok_to_continue || !phones_alike;
      },
    },
    data() {
      return {
        authenticated: false,
        ldapuser: null,
        userinfo: null,
        edit_info_id: null,
        continue_btn_text: "",
        //email
        email_change_flag: false,
        email_temp: null,
        email_confirm_temp: null,
        email_is_valid: false,
        email_confirm_is_valid: false,

        //telefon
        mobile_change_flag: false,
        mobile_temp: null,
        mobile_confirm_temp: null,
        mobile_is_valid: false,
        mobile_confirm_is_valid: false,
      };
    },
    mounted() {
      const self=this;
      self.authenticated=self.$keycloak.authenticated;
      self.ldapuser={
        "cardsrcimagesha256":self.person.cardsrcimagesha256,
        "cardsrcimageuri":self.person.cardsrcimageuri,
        "cn":self.person.cn,
        "dateofbirth":self.person.dateofbirth,
        "description":self.person.description,
        "emailaddress":self.person.emailaddress,
        "emailverified":self.person.emailverified,
        "facesrcimagesha256":self.person.facesrcimagesha256,
        "facesrcimageuri":self.person.facesrcimageuri,
        "gender":self.person.gender,
        "givenname":self.person.givenname,
        "initials":self.person.initials,
        "mail":self.person.mail,
        "mobile":self.person.mobile,
        "objectclass":self.person.objectclass,
        "phonenumberverified":self.person.phonenumberverified,
        "placeofbirth":self.person.placeofbirth,
        // "serialnumber":self.person.serialnumber[0],
        "signedpdfuri":self.person.signedpdfuri,
        "selfie":self.person.selfie,
        "idcard":self.person.idcard,
        "sn":self.person.sn,
        "uid":self.person.uid
      }
    },
    methods: {
      // KEYCLOAK
      logout() {
        const self=this;
        f7.preloader.show();
        request({
          beforeSend: function (xhr) {
            xhr.setRequestHeader ('X-CSRF-TOKEN', localStorage.token);
          },
          method: 'post',
          url: '/v/finish',
          success: function (data, status, xhr) {
            f7.preloader.hide();
            localStorage.clear();
            self.$keycloak.logout();
          },
          error: function (xhr, status, message) {
            f7.preloader.hide();
          },
          dataType: 'json'
        });
      },
      // LDAP
      ldap() {
        const self=this;
        /*
          },
          */
      },
      delete_me() {
        const self=this;
        f7.dialog.confirm(
          self.$t('edit_warning-delete-account-alert'), 
          () => {
            f7.preloader.show();
            request({
              beforeSend: function (xhr) {
                xhr.setRequestHeader ('X-CSRF-TOKEN', localStorage.token);
                xhr.setRequestHeader('Authorization','Bearer '+self.$keycloak.token);
              },
              method: 'post',
              url: '/v/delete',
              success: function (data, status, xhr) {
                f7.preloader.hide();
                if(data.pass) {
                  f7.dialog.alert(self.$t('edit_status-delete-account-success'));
                  localStorage.clear();
                  self.$keycloak.logout();
                } else {
                  if (data.err_code != null){
                    switch(data.err_code){
                      case 200:
                        f7.dialog.alert(self.$t('edit_status-delete-account-disabled'));
                        break;
                      case 300:
                        f7.dialog.alert(self.$t('edit_status-delete-user-inexistent'));
                        break;
                      case 400:
                        f7.dialog.alert(self.$t('edit_status-delete-user-exception'));
                        break;
                    }
                  }
                  else{
                    f7.dialog.alert(self.$t('edit_status-delete-account-failed'));
                  }
                }
              },
              error: function (xhr, status, message) {
                f7.preloader.hide();
                f7.dialog.alert('('+status+') '+message, self.$t('error'));
              },
              dataType: 'json'
            });              
          });
      },
      edit_info_method(id){
        const self=this;
        switch(id){
          case 1:
            self.edit_info_id=1;
            break;
          case 2:
            self.edit_info_id=2;
            break;
          case 3:
            self.edit_info_id=3;
            break;
        }
      },
      verifyEmailPin(event) {
        const self=this;
        self.$log.debug('verifyEmailPin');
        let value=event.target.value.toString();
        if(value.length>=4)
          self.verifyPin(value,'EMAIL');
      },
      verifyPhonePin(event) {
        const self=this;
        self.$log.debug('verifyPhonePin');
        let value=event.target.value.toString();
        if(value.length>=4)
          self.verifyPin(value,'SMS');
      },
      verifyPin(pin_value,pin_type) {
        const self=this;
        self.$log.debug('verifyPin');
        f7.preloader.show();

        self.$http
        .post('/v/pinvalidate', {
          type: pin_type,
          val: pin_value,
        })
        .then(function(result){
          f7.preloader.hide();
          var error_c = null;
          if (result.data.pass && result.data.err_code == 0){
            if (pin_type == 'EMAIL'){
              self.change_email_method(1, true);
            }
            else if(pin_type == 'SMS'){
              self.change_phone_method(1, true);
            }
          }
          else{
            if (result.data.err_code == 1){
              error_c = self.$t('pin_invalid');
            }
            else{
              error_c = result.data.err_msg;
            }
            f7.dialog.alert("Eroare: " + error_c);
          }
        })
        .catch(function(error){
          f7.preloader.hide();
          f7.dialog.alert(error);
          self.reset_main_infos(true);
        });
      },
      send_validationcode_email(){
        const self=this;
        f7.preloader.show();
        self.$http
          .post('/v/pinedit', {
            type: 'EMAIL',
            national_id: self.ldapuser.uid,
            new_email: self.email_temp
          })
          .then(function(result){
            f7.preloader.hide();
            var error_c = null;
            if (result.data.pass && result.data.err_code == 0){
                self.email_change_flag = true;
            }
            else{
              error_c = result.data.err_code;
              f7.dialog.alert(self.$t('edit_error-sending-validationsms-code') + error_c);
              self.reset_main_infos(true);
            }
          })
          .catch(function(error){
            f7.dialog.alert(self.$t('edit_error-sending-validationsms-code') + error.response.status);
            self.reset_main_infos(true);
          });
      },
      send_validationcode_sms(){
        const self=this;
        f7.preloader.show();
        self.$http
          .post('/v/pinedit', {
            type: 'SMS',
            national_id: self.ldapuser.uid,
            new_phone: self.mobile_temp,
            phone_country: 'RO'
          })
          .then(function(result){
            f7.preloader.hide();
            var error_c = null;
            if (result.data.pass && result.data.err_code == 0){
                self.mobile_change_flag = true;
            }
            else{
              error_c = result.data.err_code;
              f7.dialog.alert(self.$t('edit_error-sending-validationemail-code') + error_c);
              self.reset_main_infos(true);
            }
          })
          .catch(function(error){
            f7.dialog.alert(self.$t('edit_error-sending-validationemail-code') + error.response.status);
            self.reset_main_infos(true);
          });
      },
      setEmailValid(isValid) {
        const self=this;
        self.$log.debug('setEmailValid');
        self.email_is_valid=isValid;
      },
      setEmailConfirmValid(isValid) {
        const self=this;
        self.$log.debug('setEmailConfirmationValid');
        self.email_confirm_is_valid=isValid;
      },

      setPhoneValid(isValid) {
        const self=this;
        self.$log.debug('setPhoneValid');
        self.mobile_is_valid=isValid;
      },
      setPhoneConfirmValid(isValid) {
        const self=this;
        self.$log.debug('setPhoneConfirmationValid');
        self.mobile_confirm_is_valid=isValid;
      },

      reset_main_infos(redir_home = false){
        const self=this;
        self.edit_info_id = null;

        //email
        self.email_change_flag = false;
        self.email_temp = null;
        self.email_confirm_is_valid = false;
        self.email_is_valid = null;

        //phone
        self.mobile_change_flag = false;
        self.mobile_temp = null;
        self.mobile_confirm_temp = null;
        self.mobile_confirm_is_valid = false;
        if (redir_home){
          self.f7router.back();
        }
      },

      confirm_changes_method(id_val){
        const self = this;
        f7.preloader.show();
        self.$http
          .post('/v/confirmidchanges', {
            id: id_val
          })
          .then(function(result){
            f7.preloader.hide();
            if (result.data.pass && result.data.err_code == 0){
              f7.dialog.alert(self.$t('edit_alert-succes-editing-personal-info'));
              self.ldap();
              self.reset_main_infos(true);
            }
            else{
              f7.dialog.alert(self.$t('edit_alert-failed-editing-personal-info') + result.data.err_msg);
              self.reset_main_infos(true);
            }
          })
          .catch(function(exception){
            f7.preloader.hide();
            f7.dialog.alert("Eroare: " + exception.response.status);
            self.reset_main_infos(true);
          });
      },

      change_email_method(id, callMain = false){
        const self=this;
        if (callMain){
          self.confirm_changes_method(1);
        }
        else{
          self.send_validationcode_email();
        }
      },
      change_phone_method(id, callMain = false){
        const self=this;
        if (callMain){
          self.confirm_changes_method(2);
        }
        else{
          self.send_validationcode_sms();
        }
      },
    }
  }

  </script>
